var Messages = function() {
    return {
        focus_input: function() {
            if (Generic.mobile) {
                return;
            }
            var scr_top = $('html,body').scrollTop();
            $('#message_input').focus();
            $('html,body').scrollTop(scr_top);
        },
        auto_resize_heights: function() {
            if (Messages.page == 'chat') {
                $('#main_messages_content.auto-adjust-height-scrollable').height($(window).height() - Messages.v_offset);
                $('#main_contacts.auto-adjust-height-scrollable').height($(window).height() - Messages.v_offset);
                if ($(window).height() - Messages.v_offset < $('#main_messages_contents:not(.auto-adjust-height-scrollable)').height() ||
                    $('#main_messages_content:not(.auto-adjust-height-scrollable)').height() < 400) {
                    $('#main_messages_content:not(.auto-adjust-height-scrollable)').height($(window).height() - Messages.v_offset);
                }
                if ($(window).height() - Messages.v_offset < $('#main_contacts:not(.auto-adjust-height-scrollable)').height() ||
                    $('#main_contacts:not(.auto-adjust-height-scrollable)').height() < 400) {
                    $('#main_contacts:not(.auto-adjust-height-scrollable)').height($(window).height() - Messages.v_offset);
                }
            } else {
                $('#chat-container').height($(window).height() - Messages.v_offset);
                $('#main_messages_content.auto-adjust-height-scrollable').height($(window).height() - Messages.v_offset - 84);
            }
            $('#main_messages_content').scrollTop(99999999);
        },

        switch_to_contact: function(uid) {
            $('#main_messages_content').html(
                '<div class="spinner_container"><span style="display:table-cell; vertical-align:middle;" class="fa-3x">' +
                    '<i class="fas fa-circle-notch fa-spin"></i></span></div>');
            Messages.uid = uid;
            Generic.jsCookies.setItem('CHAT_UID', Messages.uid, 1800, '/');
            if (Messages.uid == 'chat') {
                $('#message_input')[0].maxLength = 150;
                Ajax.chatAdd();
            } else {
                Messages.show_chat_users = false;
                $('#online_user_list').hide();
                $('#message_input')[0].maxLength = 400;
            }
            $('#main_messages').data('uid', Messages.uid);
            $('#message_input').val('');
            Messages.auto_resize_input();
            Messages.load_messages(Messages.uid);
            if (Generic.mobile) {
                Messages.skip_mark = 0;
                $('#contacts_view').animate({
                    'opacity': 0
                }, 250);
                $('#messages_view').show().animate({
                    'left' : 0,
                }, 250);
            }
            if (Messages.page == 'chat' && !Generic.mobile) {
                Messages.skip_mark = 0;
                $('#contacts_view').hide();
                $('#messages_view').show();
            }
            Messages.focus_input();
        },

        auto_resize_input: function() {
            if (!Generic.mobile && Messages.page == 'chat') {
                if ($('#message_input').val() == '') {
                    $('#message_input').height(20);
                } else {
                    $('#message_input').height(Math.max(20, $('#message_input')[0].scrollHeight - 12));
                }
            }
        },

        init: function(uid, hidden = false, page = '') {
            if (Messages.inited) {
                return;
            }
            Messages.page = page;
            Messages.show_chat_users = false;
            Messages.hidden = hidden;
            Messages.inited = true;
            Messages.first_load = true;
            Messages.uid = uid;
            Messages.skip_mark = Generic.mobile ? 1 : 0;
            Messages.search_contact = '';
            Messages.v_offset =  Generic.mobile ?
                (Messages.page == 'chat' ? 214 : 76) :
                (Messages.page == 'chat' ? 140 : 230);
            $(window).resize(function() {
                Messages.auto_resize_heights();
            });
            Messages.auto_resize_heights();
            $('#message_input').keyup(function(event) {
                Messages.auto_resize_input();
                Messages.message_enter(this, event);
            });
            $('#contact_input').keyup(function(event) {
                Messages.contact_search(this, event);
            });
            $('#messages_cancel_search_btn').on('click', function() {
                $('#contact_input').val('');
                Messages.search_contact = '';
                Messages.load_messages(Messages.uid);
            });
            $('#chat-container').on('click', '#online_users_btn', function() {
                Messages.show_chat_users = !Messages.show_chat_users;
                if (Messages.show_chat_users) {
                    $('#online_user_list').show();
                } else {
                    $('#online_user_list').hide();
                }
            });
            $('#chat-container').on('click', '.ii__user_with_avatar', function() {
                if ($(this).data('uid') == undefined ||
                    !Generic.loggedin) {
                    return;
                }
                Messages.switch_to_contact($(this).data('uid'));
            });

            $('#chat-container').on('click', '.ii__mute_user', function() {
                if ($(this).data('uid') == undefined ||
                    !Generic.loggedin ||
                    $(this).data('action') == undefined) {
                    return;
                }
                var user_id = $(this).data('uid');
                Ajax.ignore($(this).data('action'), user_id, function() {
                    var prev = $('.ii__mute_user_' + user_id).data('action');
                    if (prev == 'ignore') {
                        $('.ii__mute_user_' + user_id).data('action', 'unigno');
                        $('.ii__mute_user_' + user_id).find('.fas').removeClass('fa-microphone').addClass('fa-microphone-slash');
                        $('.ii__mute_user_' + user_id).removeClass('clr-primary').addClass('clr-alt');
                    } else {
                        $('.ii__mute_user_' + user_id).data('action', 'ignore');
                        $('.ii__mute_user_' + user_id).find('.fas').removeClass('fa-microphone-slash').addClass('fa-microphone');
                        $('.ii__mute_user_' + user_id).removeClass('clr-alt').addClass('clr-primary');
                    }
                });
            });

            $('#msg_send_button').click(function() {
                Messages.send_message();
                $('#message_input').focus();
            });

            if (Generic.mobile) {
                $('html').css('height', 'unset');
                $('body').css('min-height', 'unset');
                $(document).on('click', '#back_to_contacts', function() {
                    Messages.skip_mark = 1;
                    $('#contacts_view').animate({
                        'opacity': 1
                    }, 250);
                    $('#messages_view').hide().animate({
                        'left' : '100%',
                    }, 250);
                });

                if (Messages.page == 'chat') {
                    $('#show_chat_btn').click(function() {
                        $('#livescore_view').hide();
                        $('#chat-container').show();
                        Messages.hidden = 0;
                        $('#show_chat_btn').addClass('t_btn_active');
                        $('#show_livescores_btn').removeClass('t_btn_active');
                    });
                    $('#show_livescores_btn').click(function() {
                        $('#livescore_view').show();
                        $('#chat-container').hide();
                        Messages.hidden = 1;
                        $('#show_chat_btn').removeClass('t_btn_active');
                        $('#show_livescores_btn').addClass('t_btn_active');
                    });
                }
            }
            if (Messages.page == 'chat' && !Generic.mobile) {
                $('#chat-container').on('click', '#back_to_contacts', function() {
                    Messages.skip_mark = 1;
                    $('#messages_view').hide();
                    $('#contacts_view').show();
                });
            }
            if (Messages.page != 'chat' &&
                Messages.page != 'messages' &&
                Generic.jsCookies.hasItem('CHAT_UID')) {
                var cookie_uid = Generic.jsCookies.getItem('CHAT_UID');
                if (Messages.uid != cookie_uid) {
                    Messages.switch_to_contact(cookie_uid);
                }
            }
            if (Messages.uid == 'chat') {
                $('#message_input')[0].maxLength = 100;
            } else {
                $('#message_input')[0].maxLength = 400;
            }
            Messages.load_messages(Messages.uid);
            Generic.init_submenus();
            setTimeout('Messages.periodic_refresh_messages();', 3 * 1000);
        },

        message_enter: function(field, event) {
            var theCode = event.keyCode ? event.keyCode : event.which ? event.which : event.charCode;
            if (theCode == 13) {
                Messages.send_message();
            }
        },

        contact_search: function(field, event) {
            var theCode = event.keyCode ? event.keyCode : event.which ? event.which : event.charCode;
            if (theCode === 27) {
                Messages.search_contact = '';
                $('#contact_input').val('');
            }
            Messages.search_contact = $('#contact_input').val();
            Messages.load_messages(Messages.uid);
        },

        should_skip_mark: function() {
            return (Messages.hidden || Messages.skip_mark) ? 1 : 0;
        },

        load_messages: function(uid) {
            Ajax.loadMessages(
                uid,
                Messages.search_contact,
                Messages.should_skip_mark(),
                Messages.page,
                (res) => {
                    Messages.update_messages(uid, res, true);
                }
            );
        },

        update_messages:function(uid, data, scrollbottom = true) {
            if (Messages.first_load) {
                scrollbottom = true;
                Messages.first_load = false;
            }
            if ($('#main_messages').data('uid') == uid &&
                data['msgs_header'] &&
                data['msgs_body'] != undefined &&
                data['contacts']) {

                var maxScrollTop = $('#main_messages_content').prop('scrollHeight') - $('#main_messages_content').innerHeight();
                var scrolledUpOffset = maxScrollTop - $('#main_messages_content').scrollTop();
                if (uid == 'chat') {
                    if ($('#chat_online_users').length == 0) {
                        $('#main_messages_header').html(data['msgs_header']);
                        Generic.init_submenus();
                    } else if ($('#chat_online_users').html() != data['msgs_userlist']) {
                        $('#chat_online_users').html(data['msgs_userlist']);
                    }
                    $('#menu-online').text(data['online_cnt'] + ' online');
                } else {
                    if (data['msgs_header'] != $('#main_messages_header').html()) {
                        $('#main_messages_header').html(data['msgs_header']);
                    }
                }
                if (data['msgs_body'] != $('#main_messages_content').html()) {
                    $('#main_messages_content').html(data['msgs_body']);
                }
                if (Messages.show_chat_users) {
                    $('#online_user_list').show();
                } else {
                    $('#online_user_list').hide();
                }
                if (Generic.mobile || Messages.page == 'chat') {
                    if (data['unread']) {
                        $('#unread_messages_w').show();
                    } else {
                        $('#unread_messages_w').hide();
                    }
                }
                if (scrollbottom) {
                    $('#main_messages_content').scrollTop(99999999);
                } else if (scrolledUpOffset < 200) {
                    $('#main_messages_content').scrollTop(99999999);
                }
                if ($('#main_contacts').html() != data['contacts']) {
                    $('#main_contacts').html(data['contacts']);
                }
            }
        },

        periodic_refresh_messages: function() {
            let uid = Messages.uid;
            Ajax.loadMessages(
                uid,
                Messages.search_contact,
                Messages.should_skip_mark(),
                Messages.page,
                (res) => {
                    Messages.update_messages(uid, res, false);
                },
                () => {
                    setTimeout('Messages.periodic_refresh_messages();', 3 * 1000);
                }
            );
        },

        send_message: function(override_body = false) {
            Generic.jsCookies.setItem('CHAT_UID', Messages.uid, 1800, '/');
            var msg = '';
            if (override_body) {
                msg = override_body.trim();
            } else {
                msg = $('#message_input').val().trim();
                if (msg == '') {
                    $('#message_input').val('');
                    return;
                }
            }
            $('#message_input').val('');
            Messages.auto_resize_input();
            let uid = Messages.uid;
            Ajax.sendMessage(
                uid,
                msg,
                Messages.search_contact,
                Messages.should_skip_mark(),
                Messages.page,
                (res) => {
                    Messages.update_messages(uid, res, true);
                    Messages.focus_input();
                }
            );
            Messages.focus_input();
        }
    };
}();

Messages.inited = false;
Messages.first_load = false;
